import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, TextField } from '@material-ui/core';
// import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { ADD, EDIT, VIEW } from '../../../common/common';

const Root = styled(Box)({
    width: '100%',
    '& .pageTitle': {
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#005E96',
    },
    '& .textWapper': {
        width: '100%',
        maxHeight: '717px',
        overflow: 'auto',
        '& .title': {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#212C31',
            marginTop: '18px',
        },
        '& .textField': {
            width: '45%',
            marginRight: '30px',
            backgroundColor: '#FFFFFF',
        },
        '& .opposing': {
            padding: '5px',
            marginBottom: '5px',
            backgroundColor: '#F2F0F3',
            '& .long': {
                width: '268px',
                margin: '5px',
                backgroundColor: '#fff',
            },
            '& .short': {
                width: '188px',
                margin: '5px',
                backgroundColor: '#fff',
            },
        },
        '& .delWapper': {
            cursor: 'pointer',
            width: '108px',
            '& .del': {
                color: '#9B9B9B',
            },
        },
    },
    '& .notesText': {
        width: '100%',
        backgroundColor: '#FFFFFF',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#d8d8d8',
        margin: '20px 0',
    },
    '& .foot': {
        margin: '10px 0',
        '& .btn': {
            marginRight: '20px',
        },
    },
})

class ClientIndividual extends Component {
    constructor(props) {
        super(props);
        this.state = {
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            wechat: "",
            referral_source: "",
            related_parties: [{
                company_name: "",
                principal_name: "",
                principal_email: "",
                principal_phone: "",
                relationship: "",
                title: ""
            }],
            note: "",
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleOpposingChange = this.handleOpposingChange.bind(this);
        this.handleAddRelated = this.handleAddRelated.bind(this);
        this.handleDelet = this.handleDelet.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }
    render() {
        // const showDelBtn = (index) => {
        //     if (index === 0 || this.isDisabled()) {
        //         return <div className="delWapper">
        //         </div>
        //     } else {
        //         return <div className="delWapper c" onClick={e => this.handleDelet(e, index)}>
        //             <DeleteForeverIcon className="del d-e"></DeleteForeverIcon>
        //         </div>
        //     }
        // }
        const { first_name, last_name, email, phone, wechat, referral_source } = this.state;
        return (
            <Root>
                <div className="textWapper">
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="first_name"
                        label="First name"
                        value={first_name}
                        onChange={e => this.handleChange(e, 'first_name')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="last_name"
                        label="Last name"
                        value={last_name}
                        onChange={e => this.handleChange(e, 'last_name')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        required
                        disabled={this.isDisabled()}
                        className="textField"
                        id="email"
                        label="Email"
                        value={email}
                        onChange={e => this.handleChange(e, 'email')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        id="phone"
                        label="Tel."
                        value={phone}
                        onChange={e => this.handleChange(e, 'phone')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        id="wechat"
                        label="Wechat (recommended)"
                        value={wechat}
                        onChange={e => this.handleChange(e, 'wechat')}
                        margin="dense"
                        variant="outlined"
                    />
                    <TextField
                        disabled={this.isDisabled()}
                        className="textField"
                        id="referral_source"
                        label="Referral Source"
                        value={referral_source}
                        onChange={e => this.handleChange(e, 'referral_source')}
                        margin="dense"
                        variant="outlined"
                    />
                    {/* <div className="title">Opposing Parties or Pelevant Parties Info</div>
                    {related_parties.map((row, index) => (
                        <div className="h" key={index}>
                            <div className="opposing">
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="company_name"
                                    label="Company"
                                    value={row.company_name}
                                    onChange={e => this.handleOpposingChange(e, index, 'company_name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="principal_name"
                                    label="Name"
                                    value={row.principal_name}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_name')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="title"
                                    label="Title"
                                    value={row.title}
                                    onChange={e => this.handleOpposingChange(e, index, 'title')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="principal_email"
                                    label="Email"
                                    value={row.principal_email}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_email')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="short"
                                    id="principal_phone"
                                    label="Tel."
                                    value={row.principal_phone}
                                    onChange={e => this.handleOpposingChange(e, index, 'principal_phone')}
                                    margin="dense"
                                    variant="outlined"
                                />
                                <TextField
                                    disabled={this.isDisabled()}
                                    className="long"
                                    id="relationship"
                                    label="Relationship"
                                    value={row.relationship}
                                    onChange={e => this.handleOpposingChange(e, index, 'relationship')}
                                    margin="dense"
                                    variant="outlined"
                                />
                            </div>
                            {showDelBtn(index)}
                        </div>
                    ))}
                    <Button disabled={this.isDisabled()} color="primary" onClick={this.handleAddRelated}>
                        <AddIcon></AddIcon>
                        Add More Parties
                    </Button> */}
                    {/* <div className="title">Notes</div>
                    <TextField
                        disabled={this.isDisabled()}
                        id="notes"
                        className="notesText"
                        margin="dense"
                        variant="outlined"
                        multiline
                        rows="4"
                        inputProps={{ 'aria-label': 'bare' }}
                        value={note}
                        onChange={e => this.handleChange(e, 'note')}
                    /> */}
                </div>
            </Root>
        )
    }
    componentDidMount() {
        this.initData();
    }
    initData() {
        const { data, state } = this.props;
        console.log(data, state)
        if (state === VIEW || state === EDIT) {
            if (data.individual) {
                const first_name = data.individual.first_name ? data.individual.first_name : "";
                const last_name = data.individual.last_name ? data.individual.last_name : "";
                const email = data.individual.email ? data.individual.email : "";
                const phone = data.individual.phone ? data.individual.phone : "";
                const wechat = data.individual.wechat ? data.individual.wechat : "";
                const referral_source = data.referral_source ? data.referral_source : "";
                const related_parties = data.related_parties ? data.related_parties : "";
                const note = data.note ? data.note : "";
                this.setState(() => ({
                    first_name,
                    last_name,
                    email,
                    phone,
                    wechat,
                    referral_source,
                    related_parties,
                    note,
                }));
            }
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleOpposingChange(e, index, name) {
        const value = e.target.value;
        const { related_parties } = this.state;
        let arr = related_parties;
        arr[index][name] = value;
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleAddRelated() {
        const { related_parties } = this.state;
        console.log(related_parties);
        let obj = {
            company_name: "",
            principal_name: "",
            principal_email: "",
            principal_phone: "",
            relationship: "",
            title: ""
        }
        let arr = related_parties;
        arr.push(obj)
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleDelet(e, index) {
        console.log(index)
        const { related_parties } = this.state;
        let arr = related_parties;
        arr.splice(index, 1);
        this.setState(() => ({
            related_parties: arr
        }))
    }
    handleSelect(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleGetData() {
        const {
            first_name,
            last_name,
            email,
            phone,
            wechat,
            referral_source,
            // related_parties,
            note
        } = this.state;
        const obj = {
            first_name,
            last_name,
            email,
            phone,
            wechat,
            referral_source,
            // related_parties,
            note
        }
        return obj;
    }
    handleCancel() {
        this.props.handleCancel();
    }

    btnName(state) {
        if (state === ADD) {
            return "CREATE";
        } else if (state === EDIT) {
            return "SAVE";
        }
    }
}

export default ClientIndividual;